import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import {
  DISCLOSED_CHIP_TITLE,
  NOT_DISCLOSED_CHIP_TITLE,
} from '../../../../LoanCicHistory.constants';

export const DISCLOSED_CHIP = { title: DISCLOSED_CHIP_TITLE, variant: LabelVariant.GREEN };

export const NOT_DISCLOSED_CHIP = { title: NOT_DISCLOSED_CHIP_TITLE, variant: LabelVariant.GRAY };
